const TriggerBalanceUpdate = ({ balance, usdt } = {}) => {
    if (balance != null) localStorage.setItem("balance", balance);
    if (usdt != null) localStorage.setItem("usdt_balance", usdt);
    window.dispatchEvent(new Event("balanceUpdated"));
};

export { TriggerBalanceUpdate };